import {Chip} from "@material-ui/core"
import {useStyles} from "./styles"

export function StatusChip({ status }) {
  const classes = useStyles()
  if (status === 'finished') {
    return <Chip label="FINALIZADO" className={classes.chipFinished} size="small" />
  }
  if (status === 'started') {
    return <Chip label="NÃO FINALIZADA" className={classes.chipNotFinished} size="small" />
  }
  return <Chip label="NÃO INICIADA" size="small" />
}

export function StatusPrintedChip({ status }) {
  const classes = useStyles()
  if (status === 'finished') {
    return <Chip label="FINALIZADO" className={classes.chipFinished} size="small" />
  }
  return <Chip label="AGUARDANDO RESULTADOS" size="small" />
}